import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { createHighlighter } from 'shiki';

@Pipe({
  name: 'codeToHtml',
  standalone: true,
})
export class CodeToHtmlPipe implements PipeTransform {
  constructor(private readonly domSanitizer: DomSanitizer) {}

  async transform(code: string): Promise<SafeHtml> {
    const highlighter = await createHighlighter({
      langs: ['javascript'],
      themes: ['vitesse-dark'],
    });
    await highlighter.loadLanguage('javascript');
    await highlighter.loadTheme('vitesse-dark');
    const html = highlighter.codeToHtml(code, {
      lang: 'javascript',
      theme: 'vitesse-dark',
    });
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }
}
